<ion-header #header>
  <leplace-toolbar *ngIf="loadedPage" [menu]="false" [title]="title"
    [leftButton]="(isModal || fromMarket) ? appIconsStandard.back : appIconsStandard.home"
    [leftButtonDisabled]="linkPreview" [leftIcon]="true" (leftClick)="back()" [rightButton]="appIconsStandard.settings"
    [rightIcon]="true" (rightClick)="presentPopover()" [loading]="false">
  </leplace-toolbar>
</ion-header>

<!-- overflow-scroll="true" -->

<ion-content [ngClass]="theme" #content>
  <!-- (swipe)="swipeEvent($event)" -->
  <div class="view-frame view-frame-border">
    <!-- bg-filter-1 -->
    <div class="bg-container bg-container-fill" [photoBg]="{fade: true, fadeClass: 'bg-container-fade', url: photoUrl}">

      <leplace-chat-widget lane="customer" source="lp_connect" [prefill]="{ story_id: storyId }">
      </leplace-chat-widget>

      <div class="content">

        <div *ngIf="!loaded" class="progress-spinner-center">
          <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate">
          </mat-progress-spinner>
        </div>

        <div *ngIf="loaded" fxLayout="column" class="content-height no-scroll">

          <div class="scrollbar-y custom-scrollbar content-height" fxLayout="column" (scroll)='onContentScroll($event)'>
            <div *ngIf="storyLoaded" class="text-color-overlay margin-horizontal-s margin-top-s margin-bottom-s">

              <div [innerHTML]="infoText.connectHeader"
                class="info-text-m description-frame text-color-primary text-center">
              </div>

              <div [innerHTML]="infoText.connectNotes"
                class="info-text-s description-frame text-color-primary text-center">
              </div>

              <div class="theme-border-top margin-vertical-s"></div>

              <ion-row class="padding-xs">
                <ion-col size="12" class="text-center">
                  <span class="heading text-color-primary">{{story.name}}</span>
                </ion-col>
              </ion-row>

              <story-info-spec *ngIf="storyExt" [data]="storyExt"></story-info-spec>

              <ion-row class="padding-xs" *ngIf="storyExt && storyExt.modeText">
                <ion-col size="12" class="text-center">
                  <span class="info-text-s text-color-primary">{{storyExt.modeText}}</span>
                </ion-col>
              </ion-row>

              <ion-row class="padding-xs">
                <ion-col size="12" class="text-center">
                  <span class="info-text-m text-color-primary">{{levelDisp}}</span>
                </ion-col>
              </ion-row>

              <div tappable class="padding-xs text-center" *ngIf="isBeta">
                <span class="as-text element-selector info-text-s text-color-primary">UNLISTED</span>
              </div>

              <div tappable class="padding-xs text-center" *ngIf="isDev">
                <span class="as-text element-selector info-text-s text-color-primary">DEV</span>
              </div>

              <ion-row *ngIf="story.regionType">
                <ion-col size="12">
                  <div>
                    <span class="info-text-s margin-top-s bold text-color-element">{{story.regionType}}</span>
                  </div>
                </ion-col>
              </ion-row>

              <ion-row *ngIf="languageDisp">
                <ion-col size="12">
                  <ion-button class="action-button-fill-xs button-color-transparent" (click)="switchLanguage()">
                    <span class="button-font-size-s">{{languageDisp.nameLocale}}</span>
                    <icon-wrapper class="slot-icon-padding" slot="start" [icon]="languageDisp.icon" [custom]="true">
                    </icon-wrapper>
                  </ion-button>
                </ion-col>
              </ion-row>

              <div class="theme-border-top margin-vertical-s"></div>

              <safe-html-renderer [imageWrapper]="true" [unsafeHtmlContent]="description"
                innerClass="info-text-m description-frame text-color-primary text-left padding-horizontal-s"></safe-html-renderer>

              <div class="margin-top-m">
                <a class="info-text-m bold text-color-primary no-underline element-selector"
                  (click)="scrollTo('sectionActivate')">{{'connect:labels.availableIn' |
                  i18next}} Leplace World app</a>
              </div>

              <ion-row *ngIf="storyPhotos && activeCards.preview">
                <ion-col class="padding-s center-text">
                  <span class="center-text info-text-mlg bold text-color-primary">{{'story:labels.inGamePreview' |
                    i18next}}</span>
                </ion-col>
              </ion-row>

              <div class="bootstrap-carousel margin-top-s carousel-center-size"
                *ngIf="storyPhotos && activeCards.preview">
                <ngb-carousel>
                  <ng-template *ngFor="let sp of storyPhotos; let i = index" ngbSlide>
                    <div class="picsum-img-wrapper center-text ngb-slider-img-padding">
                      <img [src]="sp.photoUrl" class="slide-image-inner-modal">
                    </div>
                    <div class="carousel-caption">
                      <span class="center-text info-text-m bold text-color-primary">{{sp.name}}</span>
                    </div>
                  </ng-template>
                </ngb-carousel>
              </div>

              <div tappable class="padding-xs text-center" *ngIf="descriptionFooter && !isBundle"
                (click)="scrollToStart()">
                <span class="as-text element-selector button-font-size-mlg text-color-primary">{{descriptionFooterKey |
                  i18next}}</span>
              </div>

              <div id="sectionActivateCheckout" *ngIf="activeCards.registerTester"
                class="text-color-overlay-flush margin-horizontal-s margin-top-s margin-bottom-m">

                <booking-form [bookingDateSelector]="bookingDateSelector" [bookingData]="bookingData"
                  introLabel="Sign up for a free pass and access to the Leplace World community*"
                  footerLabel="*limited time offer exclusive for testers" submitLabel="Get free pass*"
                  (submit)="getFreePass($event)"></booking-form>

              </div>

              <div class="text-color-overlay-flush margin-horizontal-s margin-top-s margin-bottom-s"
                *ngIf="hasProviders">
                <ion-list class="list-padding">
                  <span class="info-text-mlg bold text-color-primary padding-horizontal-s">{{'story:labels.providedBy' |
                    i18next}}</span>
                  <ion-item *ngFor="let bloc of storyProviders; let i = index;" class="list-item transparent-bg"
                    no-lines>
                    <place-items-card class="full-w" *ngIf="bloc" [location]="bloc" tappable
                      (click)="getPlaceDetails(i)">
                    </place-items-card>
                  </ion-item>
                </ion-list>
              </div>

              <div *ngIf="isBundle" class="padding-top-s">
                <span class="center-text info-text-lg bold text-color-primary">{{'connect:labels.bundleContent' |
                  i18next}}</span>
                <ion-list class="list-padding">
                  <ion-item class="list-item list-item-card-padding transparent-bg"
                    *ngFor="let item of bundleContents; let i = index" #slidingItem [hidden]="item.hide">
                    <story-info [data]="item" class="icon-color-primary full-w" tappable [showCategory]="true"
                      [large]="item.large" (click)="goToBundleStoryDetail(item.story, i)" [reload]="false"></story-info>
                  </ion-item>
                </ion-list>
              </div>

              <div class="padding-top-s">
                <span class="center-text info-text-lg bold text-color-primary">{{'connect:labels.mapPreview' |
                  i18next}}</span>
              </div>

              <ion-row *ngIf="infoText.mapPreview" class="center-items margin-top-s margin-bottom-s">
                <ion-col size="2">
                  <img [src]="infoText.mapPreviewIcon" class="img-xxs" />
                </ion-col>
                <ion-col size="10">
                  <div [innerHTML]="infoText.mapPreview"
                    class="info-text-m description-frame text-color-primary text-left">
                  </div>
                </ion-col>
              </ion-row>

              <leplace-map class="padding-top-s map-view-selector-inline" mapClass="map-view-selector-inline"
                [showSearch]="false" [showFab]="true" [markers]="storyMarkers" [fitBoundsOnMarkers]="true"
                [center]="mapCenter" [zoom]="zoomLevel" [loading]="loading" [cluster]="true" [reload]="reloadMap"
                (markerClicked)="onMarkerClicked($event)">
              </leplace-map>

              <div id="sectionHowItWorks" *ngIf="activeCards.tutorial">
                <ion-row class="theme-border-heading">
                  <ion-col class="padding-s center-text">
                    <span class="center-text info-text-lg bold text-color-primary">{{'connect:labels.activationGuide' |
                      i18next}}</span>
                  </ion-col>
                </ion-row>

                <!-- overview -->

                <ion-row *ngIf="infoText.howItWorks" class="center-items margin-top-s margin-bottom-s">
                  <ion-col size="2">
                    <img [src]="infoText.howItWorksIcon" class="img-xxs" />
                  </ion-col>
                  <ion-col size="10">
                    <div [innerHTML]="infoText.howItWorks"
                      class="info-text-m description-frame text-color-primary text-left">
                    </div>
                  </ion-col>
                </ion-row>

                <!-- <div *ngIf="tutorialVideoUrl" class="margin-top-xs margin-bottom-xs">
                  <youtube-view [videoUrl]="tutorialVideoUrl" customClass="video-portrait-mobile"></youtube-view>
                </div> -->

                <!-- <div *ngIf="tutorialVideoUrl" class="margin-top-s margin-bottom-xs">
                  <youtube-view [videoUrl]="tutorialVideoUrl" customClass="video-landscape"></youtube-view>
                </div> -->

                <div class="text-color-overlay-flush margin-horizontal-s margin-top-s margin-bottom-s">
                  <div *ngIf="extDataLoaded">
                    <div class="text-left margin-horizontal-s margin-top-s">
                      <div *ngFor="let e of faqActivation.faqEntries"
                        class="list-item list-item-padding transparent-bg">
                        <div class="center-text margin-top-s">
                          <span class="info-text-m bold text-color-primary">{{e.name}}</span>
                        </div>
                        <plain-entry-expand [e]="e" [fixed]="true"></plain-entry-expand>
                      </div>
                    </div>
                  </div>

                  <!-- unlock codes -->

                  <div class="padding-s info-text-m description-frame text-color-primary text-left"
                    [innerHTML]="infoText.findStoryNotes">
                  </div>

                  <div *ngIf="!unlockCodes">
                    <ion-row>
                      <ion-col class="padding-s text-left">
                        <span class="text-left info-text-m bold text-color-primary">{{'connect:labels.sampleUnlockCode'
                          | i18next}}</span>
                      </ion-col>
                    </ion-row>
                    <div>
                      <edit-code [(prop)]="defaultUnlock" placeholder="N/A" [numeric]="false"
                        [dim]="defaultUnlock.length" [autocaps]="false" [disabled]="true">
                        <inner-content></inner-content>
                      </edit-code>
                    </div>
                  </div>

                  <div *ngIf="unlockCodes">
                    <ion-row>
                      <ion-col class="padding-s text-left">
                        <span class="text-left info-text-m bold text-color-primary">{{'connect:labels.unlockCodes'
                          | i18next}}</span>
                      </ion-col>
                    </ion-row>
                    <ion-row *ngFor="let uc of unlockCodes">
                      <ion-col size="12">
                        <div class="border-frame">
                          <edit-code [disabled]="true" [prop]="uc" placeholder="" [numeric]="false"
                            [dim]="unlockCodeShortLength" [autocaps]="true">
                          </edit-code>
                        </div>
                      </ion-col>
                    </ion-row>
                  </div>

                  <div class="padding-s info-text-m description-frame text-color-primary text-left"
                    [innerHTML]="infoText.unlockNotes">
                  </div>

                  <div class="text-color-overlay-flush margin-horizontal-s margin-top-s margin-bottom-s"
                    *ngIf="hasActivationCodes">

                    <ion-row>
                      <ion-col class="padding-s center-text">
                        <span class="center-text info-text-mlg bold text-color-primary">{{'connect:labels.inputCodes'
                          | i18next}}</span>
                      </ion-col>
                    </ion-row>

                    <div *ngFor="let code of activationCodesList">
                      <div class="border-frame">
                        <edit-code [(prop)]="code.code" placeholder="N/A" [numeric]="false" [dim]="code.length"
                          [autocaps]="false" [disabled]="true">
                          <inner-content>{{code.name}}</inner-content>
                        </edit-code>
                        <ion-button class="as-text element-selector info-text-s text-color-primary"
                          (click)="copyToClipboard(code.code)">
                          <icon-wrapper slot="icon-only" [icon]="appIconsStandard.clipboard"
                            [custom]="false"></icon-wrapper>
                        </ion-button>
                      </div>
                    </div>

                    <div *ngIf="(hasActivationQRCodes && !partnerUnlock) || hasRedeemQRCodes"
                      class="theme-border-top margin-vertical-s">
                      <ion-row class="margin-top-s">
                        <ion-col class="padding-s center-text">
                          <span class="center-text info-text-mlg bold text-color-primary">{{'connect:labels.qrCodes'
                            | i18next}}</span>
                        </ion-col>
                      </ion-row>
                      <ngb-carousel class="margin-top-s">
                        <ng-template *ngFor="let code of activationCodesQRList; let i = index" ngbSlide>
                          <div class="picsum-img-wrapper ngb-slider-img-padding">
                            <qr-code [index]="i" [code]="code.code" [version]="6" [interact]="false">
                            </qr-code>
                          </div>
                          <div class="carousel-caption">
                            <span class="center-text info-text-m bold text-color-primary">{{code.name}}</span>
                          </div>
                        </ng-template>
                      </ngb-carousel>
                    </div>
                    <div *ngIf="partnerUnlock">
                      <ion-row>
                        <ion-col class="padding-s center-text">
                          <span
                            class="center-text info-text-mlg bold text-color-primary">{{'connect:labels.unlockCodesAvailable'
                            | i18next}}</span>
                        </ion-col>
                      </ion-row>
                    </div>
                  </div>

                  <div class="padding-s" *ngIf="activeCards.checkBooking">
                    <booking-check *ngIf="settings" [settings]="settings"
                      (action)="bookingCheckAction($event)"></booking-check>
                  </div>

                </div>

                <!-- activation extra -->

                <ion-row>
                  <ion-col size="12">
                    <ion-button class="as-text element-selector height-auto" (click)="toggleActivationGuide()">
                      <span class="button-font-size-s">{{'connect:labels.learnMore'
                        | i18next}}</span>
                      <icon-wrapper slot="start" [icon]="appIconsStandard.clipboard" class="slot-icon-padding">
                      </icon-wrapper>
                    </ion-button>
                  </ion-col>
                </ion-row>

                <div *ngIf="showActivationGuide">

                  <div *ngIf="!isModal && tutorialVideoUrl" class="margin-top-s margin-bottom-xs">
                    <youtube-view [videoUrl]="tutorialVideoUrl" [portrait]="true"
                      customClass="video-portrait-mobile"></youtube-view>
                  </div>

                  <ion-row *ngIf="showActivationPDFGuide && tutorialEmbed" class="margin-top-s margin-bottom-xs">
                    <ion-col size="12">
                      <div [innerHTML]="tutorialEmbed"
                        class="info-text-m description-frame text-color-primary padding-top-s">
                      </div>
                    </ion-col>
                  </ion-row>

                  <ion-row *ngIf="showActivationPDFGuide && tutorialEmbedPDFLink" class="margin-top-s margin-bottom-xs">
                    <ion-col size="12">
                      <!-- <iframe [src]="tutorialEmbedPDFLink" class="view-frame-pdf item-border-radius">
                    </iframe> -->
                      <object [data]="tutorialEmbedPDFLink" type="application/pdf"
                        class="view-frame-pdf item-border-radius">
                        <iframe
                          [src]="'https://docs.google.com/viewer?url=' + tutorialEmbedPDFLink + '&embedded=true'"></iframe>
                      </object>
                    </ion-col>
                  </ion-row>

                  <ion-row *ngIf="showActivationPDFGuide && tutorialPreviewLink">
                    <ion-col size="12">
                      <img [src]="tutorialPreviewLink" class="full-w item-border-radius" style="max-width: 600px;">
                    </ion-col>
                  </ion-row>

                  <!-- <ion-row>
                <ion-col size="12">
                  <ion-button class="as-text element-selector height-auto" (click)="downloadTutorial()">
                    <span class="button-font-size-s">Download PDF</span>
                    <icon-wrapper slot="start" [icon]="appIconsStandard.download" class="slot-icon-padding">
                    </icon-wrapper>
                  </ion-button>
                </ion-col>
              </ion-row> -->

                </div>

              </div>

              <div id="sectionActivate" *ngIf="activeCards.setup">
                <ion-row class="theme-border-heading">
                  <ion-col class="padding-s center-text">
                    <span class="center-text info-text-lg bold text-color-primary">{{'connect:labels.getLeplaceWorld'
                      | i18next}}</span>
                  </ion-col>
                </ion-row>

                <div class="padding-s info-text-m description-frame text-color-primary text-left"
                  [innerHTML]="infoText.appNotes">
                </div>

                <div class="text-color-overlay-flush margin-horizontal-s margin-top-s margin-bottom-s">
                  <div>
                    <ion-row>
                      <ion-col class="padding-s center-text">
                        <span
                          class="center-text info-text-m bold text-color-primary">{{'connect:labels.publicAccessLimited'
                          | i18next}}</span>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="12" size-md="6" class="flex-column">
                        <ion-button class="as-text element-selector height-auto" [disabled]="!isPlayStore()"
                          (click)="goToPlayStore()">
                          <img [src]="imgIcons.playStore" class="img-xs" />
                        </ion-button>
                        <div *ngIf="!isPlayStore()" class="info-text-m description-frame text-color-primary text-left"
                          [innerHTML]="infoText.playStoreNotes"></div>
                        <!-- <span *ngIf="!dist.android"
                          class="center-text info-text-m bold text-color-primary">(unavailable)</span> -->
                      </ion-col>
                      <ion-col size="12" size-md="6" class="flex-column">
                        <ion-button class="as-text element-selector height-auto" [disabled]="!isAppStore()"
                          (click)="goToAppStore()">
                          <img [src]="imgIcons.appStore" class="img-xs" />
                        </ion-button>
                        <div *ngIf="!isAppStore()" class="info-text-m description-frame text-color-primary text-left"
                          [innerHTML]="infoText.appStoreNotes"></div>
                        <!-- <span *ngIf="!dist.ios || isTestFlightOnly"
                          class="center-text info-text-m bold text-color-primary">(unavailable)</span> -->
                      </ion-col>
                    </ion-row>
                  </div>

                  <div class="theme-border-top margin-vertical-s">
                    <ion-row>
                      <ion-col class="padding-s center-text">
                        <span
                          class="center-text info-text-m bold text-color-primary">{{'connect:labels.earlyAccessWorld'
                          | i18next}}</span>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="12" size-md="12">
                        <ion-button class="as-text element-selector height-auto" (click)="goToAppleTestFlight()">
                          <img [src]="imgIcons.testFlight" class="img-xs" />
                        </ion-button>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="12" size-md="12">
                        <div class="info-text-m description-frame text-color-primary text-left"
                          [innerHTML]="infoText.testFlightNotes"></div>
                      </ion-col>
                    </ion-row>
                  </div>

                  <div class="theme-border-top margin-vertical-s" *ngIf="enableWeb">
                    <ion-row>
                      <ion-col class="padding-s center-text">
                        <span class="center-text info-text-m bold text-color-primary">{{'connect:labels.webWorld'
                          | i18next}}</span>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="12" size-md="12">
                        <ion-button class="as-text element-selector height-auto" (click)="goToWeb()">
                          <img [src]="imgIcons.web" class="img-xs" />
                        </ion-button>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="12" size-md="12">
                        <div class="info-text-m description-frame text-color-primary text-left"
                          [innerHTML]="infoText.webNotes">
                        </div>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="12">
                        <ion-button class="as-text element-selector height-auto text-transform-none"
                          (click)="goToWeb()">
                          <span class="button-font-size-s">{{webUrlDisp}}</span>
                          <icon-wrapper slot="start" icon="globe" class="slot-icon-padding">
                          </icon-wrapper>
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </div>

                  <!-- <ion-row class="padding-vertical-none">
                  <ion-col size="6" class="padding-vertical-none">
                    <span class="info-text-s">Play Store</span>
                  </ion-col>
                  <ion-col size="6" class="padding-vertical-none">
                    <span class="info-text-s">Apple Test Flight</span>
                  </ion-col>
                </ion-row> -->

                  <!-- <ion-row>
                    <ion-col size="12">
                      <ion-button class="as-text element-selector height-auto text-transform-none"
                        (click)="openWebpage()">
                        <span class="button-font-size-s">www.leplace.online</span>
                        <icon-wrapper slot="start" icon="globe" class="slot-icon-padding">
                        </icon-wrapper>
                      </ion-button>
                    </ion-col>
                  </ion-row> -->

                </div>
              </div>

              <div id="sectionActivateCheckout" *ngIf="activeCards.checkout">
                <ion-row class="theme-border-heading">
                  <ion-col class="padding-s center-text">
                    <span class="center-text info-text-lg bold text-color-primary">{{'connect:labels.checkout'
                      | i18next}}</span>
                  </ion-col>
                </ion-row>

                <div class="padding-s info-text-m description-frame text-color-primary text-left"
                  [innerHTML]="infoText.checkoutNotes">
                </div>

                <iap-card *ngIf="story.itemIap" [content]="story.itemIap" [promo]="story.itemIapPromo"></iap-card>

                <stripe-card *ngIf="enableCheckout && useStripe" [price]="alternativePrice"
                  [promo]="alternativePricePromo" (checkout)="checkoutStripe()"></stripe-card>

                <stripe-card *ngIf="enableCheckout && !useStripe" [price]="alternativePrice"
                  [promo]="alternativePricePromo" [noLogo]="true" (checkout)="checkoutWithShopify()"></stripe-card>

                <ion-row *ngIf="enableCheckout && !useStripe">
                  <ion-col class="padding-s center-text">
                    <span class="center-text info-text-mlg bold text-color-primary">{{'connect:labels.checkoutShopify'
                      | i18next}}</span>
                  </ion-col>
                </ion-row>
              </div>

              <div id="sectionActivateCheckout" *ngIf="activeCards.checkoutMore">
                <ion-button class="action-button-fill button-color-alternate" (click)="toggleCheckout()">
                  <span class="button-font-size-m bold">{{buyMoreLabel}}</span>
                </ion-button>
              </div>


              <div id="sectionViewListings" *ngIf="activeCards.viewListings">
                <ion-row *ngIf="hasStoryProducts">
                  <ion-col class="padding-s center-text">
                    <span class="center-text info-text-mlg bold text-color-primary">{{'connect:labels.alsoAvailableOn'
                      | i18next}}</span>
                  </ion-col>
                </ion-row>

                <div class="bootstrap-carousel margin-top-s" *ngIf="hasStoryProducts">
                  <ngb-carousel id="carousel" [interval]="0" [animation]="false"
                    (slid)="onProviderSlideSelected($event)">
                    <ng-template *ngFor="let product of storyProducts; let i = index" ngbSlide>
                      <div class="picsum-img-wrapper center-text ngb-slider-img-padding-large">
                        <div class="carousel-overlay-description">
                          <div *ngIf="product.title" [innerHTML]="product.title"
                            class="info-text-s text-color-overlay-s">
                          </div>
                        </div>
                        <img *ngIf="product.providerOta" [src]="product.providerOta.photoUrl"
                          class="slide-image-inner-modal slide-image-inner-modal-provider">
                      </div>
                      <div class="carousel-caption">
                        <ion-button *ngIf="product.providerOta"
                          class="as-text element-selector info-text-s text-color-primary text-transform-none"
                          (click)="openLink(product.link)">
                          <span class="button-font-size-s">{{'connect:labels.viewOn'
                            | i18next}} {{product.providerOta.name}}</span>
                        </ion-button>
                      </div>
                    </ng-template>
                  </ngb-carousel>
                </div>
              </div>

              <!-- text-color-overlay-flush  -->

              <div id="sectionFAQ" class="margin-horizontal-s margin-top-m margin-bottom-s"
                *ngIf="extDataLoaded && activeCards.faq">
                <ion-row class="theme-border-heading">
                  <ion-col class="padding-s center-text">
                    <span class="center-text info-text-lg bold text-color-primary">{{'story:labels.notes' |
                      i18next}}</span>
                  </ion-col>
                </ion-row>
                <div class="text-left">
                  <div *ngFor="let fc of faqCategories" class="list-item list-item-padding transparent-bg">
                    <div *ngFor="let e of fc.faqEntries" class="list-item list-item-padding transparent-bg">
                      <plain-entry-expand [e]="e" [fixed]="true"></plain-entry-expand>
                    </div>
                  </div>
                </div>
              </div>

              <div id="sectionContact" *ngIf="activeCards.contact">
                <ion-row class="theme-border-heading">
                  <ion-col class="padding-s center-text">
                    <span class="center-text info-text-lg bold text-color-primary">{{'connect:labels.contact'
                      | i18next}}</span>
                  </ion-col>
                </ion-row>

                <ion-row *ngIf="infoText.reviewContact" class="center-items">
                  <ion-col size="2">
                    <img [src]="infoText.reviewContactIcon" class="img-xxs" />
                  </ion-col>
                  <ion-col size="10">
                    <div [innerHTML]="infoText.reviewContact"
                      class="info-text-m description-frame text-color-primary text-left">
                    </div>
                  </ion-col>
                </ion-row>

                <div>
                  <!-- <ion-grid class="full-w">
                    <ion-row>
                      <ion-col size="6">
                        <ion-button class="action-button-fill button-color-primary" (click)="openFBPage()">
                          <icon-wrapper slot="icon-only" icon="logo-facebook"></icon-wrapper>
                        </ion-button>
                      </ion-col>
                      <ion-col size="6">
                        <ion-button class="action-button-fill button-color-primary" (click)="contact()">
                          <icon-wrapper slot="icon-only" icon="mail"></icon-wrapper>
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </ion-grid> -->

                  <ion-grid class="full-w">
                    <ion-row>
                      <ion-col size="6">
                        <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                          (click)="openWebpage()">
                          <span class="button-font-size-s">WEB</span>
                          <icon-wrapper slot="start" icon="globe" class="slot-icon-padding">
                          </icon-wrapper>
                        </ion-button>
                      </ion-col>
                      <ion-col size="6">
                        <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                          (click)="contact()">
                          <span class="button-font-size-s">EMAIL</span>
                          <icon-wrapper slot="start" icon="mail" class="slot-icon-padding">
                          </icon-wrapper>
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </div>
              </div>

              <div class="theme-border-heading"></div>

              <ion-row #startButtonBar>
                <ion-col size="2">
                  <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                    (click)="openFBPage()">
                    <!-- <span class="button-font-size-s">Facebook</span> -->
                    <icon-wrapper slot="icon-only" icon="logo-facebook">
                    </icon-wrapper>
                  </ion-button>
                </ion-col>
                <ion-col size="8">
                  <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                    (click)="openWebpage()">
                    <icon-wrapper slot="icon-only" icon="globe">
                    </icon-wrapper>
                  </ion-button>
                </ion-col>
                <ion-col size="2">
                  <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                    (click)="contact()">
                    <!-- <span class="button-font-size-s">Email</span> -->
                    <icon-wrapper slot="icon-only" icon="mail">
                    </icon-wrapper>
                  </ion-button>
                </ion-col>
              </ion-row>


              <ion-row>
                <ion-col size="12">
                  <ion-button class="as-text element-selector height-auto text-transform-none" (click)="openWebpage()">
                    <span class="button-font-size-s">www.leplace.online</span>
                    <!-- <icon-wrapper slot="start" icon="globe" class="slot-icon-padding">
                    </icon-wrapper> -->
                  </ion-button>
                </ion-col>
              </ion-row>

              <!-- <a class="as-text element-selector height-auto text-transform-none"
                href="mailto:office@leplace.online">Email</a> -->

            </div>

          </div>

          <!-- <div fxFlex></div>

          <div>
            <ion-grid class="full-w padding-bottom-xs">
              <ion-row>
                <ion-col size="12">
                  <ion-button class="action-button-fit button-color-primary-70" (click)="openWebpage()" icon-end>
                    <span class="button-font-size-s">www.leplace.online</span>
                    <icon-wrapper slot="start" icon="globe" class="slot-icon-padding">
                    </icon-wrapper>
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div> -->

        </div>
      </div>
    </div>
  </div>
</ion-content>